/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Email_Continue_LabelInputs */

const en_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with email`)
};

const de_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit E-Mail fortfahren`)
};

const pt_br2_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com e-mail`)
};

const tr_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta ile devam et`)
};

const zh_cn2_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用电子邮箱继续`)
};

const zh_hk2_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用電郵繼續`)
};

const ko_kr2_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일로 계속`)
};

const ru_ru2_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить с электронной почтой`)
};

const es_419_login_page_email_continue_label = /** @type {(inputs: Login_Page_Email_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con correo electrónico`)
};

/**
* | output |
* | --- |
* | "Continue with email" |
*
* @param {Login_Page_Email_Continue_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_email_continue_label = /** @type {((inputs?: Login_Page_Email_Continue_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Email_Continue_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_email_continue_label(inputs)
	if (locale === "de") return de_login_page_email_continue_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_email_continue_label(inputs)
	if (locale === "tr") return tr_login_page_email_continue_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_email_continue_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_email_continue_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_email_continue_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_email_continue_label(inputs)
	return es_419_login_page_email_continue_label(inputs)
});